import React from 'react'

export class Guide extends React.Component {
  render() {
    return <div className="container-fluid pt-4" style={{ minHeight: "300px" }}>
        <h2>Guide</h2>
        <h4>If you need to clarify any part of your application, refer to:</h4>
        <ul>
            <li>
                <a href="https://www.austrade.gov.au/ArticleDocuments/1433/EMDG-A-Guide-Applying.pdf.aspx" target="_blank">A guide to applying for EMDG (PDF)</a>
            </li>
            <li>
                <a href="https://www.austrade.gov.au/ArticleDocuments/6925/Guide-to-navigating-and-inputting-data-in-the-EMDG-application-form.pdf.aspx" target="_blank">A guide to navigating and inputting data in the EMDG application form (PDF)</a>
            </li>
            <li>
                <a href="https://youtu.be/8MPycuIBnj4" target="_blank">Demonstration: EMDG application form schedule bulk data upload (YouTube)</a>
            </li>
            <li>
                <a href="https://youtu.be/iT1F5vtMsVw" target="_blank">Demonstration: EMDG application form schedule direct data entry (YouTube)</a>
            </li>
            <li>
                <a href="https://www.austrade.gov.au/en/contact-us" target="_blank">Contact Austrade</a>
            </li>
            <li>
                <a href="https://www.austrade.gov.au/ArticleDocuments/6925/EMDG_frequently_asked_questions.pdf.aspx" target="_blank">Frequently asked questions (PDF)</a>
            </li>
        </ul>
    </div>
  }
}
